/** @jsx jsx */
import { css, keyframes, jsx } from '@compiled/react';
import { B400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

export const DURATION = 300;

const loadingbar = keyframes({
	from: { width: '0%' },
	to: { width: '100%' },
});

const loadingBarStyles = css({
	display: 'block',
	background: token('color.background.accent.blue.bolder', B400),
	height: '3px',
	animationName: loadingbar,
	animationDuration: `${DURATION}ms`,
	animationTimingFunction: 'ease-in-out',
});

export const LoadingBar = () => (
	<div
		css={loadingBarStyles}
		data-testid="admin-pages-common.ui.sidebar.loading-bar"
		role="presentation" // used only as a short animation
	/>
);
